var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tiptap',{attrs:{"readonly":!_vm.isAllowedPrint,"editable":false,"height":"100%","width":"100%","extensions":_vm.extensions,"tooltip":false,"showMenubar":false,"content":_vm.content},on:{"onInit":_vm.onInit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }